import { makeAutoObservable } from "mobx";
import MailControllerRepository from "../repositories/MailControllerRepository";

export class MailControllerViewModel {
  private static instance: MailControllerViewModel | null = null;

  static getInstance(): MailControllerViewModel {
    if (!MailControllerViewModel.instance) {
      MailControllerViewModel.instance = new MailControllerViewModel();
    }
    return MailControllerViewModel.instance;
  }
  private constructor() {
    makeAutoObservable(this);
  }

  public sendContestmail(
    fullName: string,
    email: string,
    shinGuardPreview: Blob,
    zipFile: Blob
  ) {
    return MailControllerRepository.sendContestmail(
      fullName,
      email,
      shinGuardPreview,
      zipFile
    );
  }
}
